import { IUnit, IUnitConversion } from "@protoplan/types";
import { axiosInstance } from "./axiosInstance";

export async function getUnits(filters?: { productId?: number, unitId?: number })
{
  return axiosInstance.post("/units/units", filters)
    .then(resJson => resJson.data as IUnit[])
    .catch(error =>
    {
      console.log("Error retrieving units:", error);
      return [] as IUnit[];
    });
}

export async function getUnitConversions(productId?: number)
{
  return axiosInstance.post("/units/unitConversions", { productId })
    .then(resJson => resJson.data as IUnitConversion[])
    .catch(error =>
    {
      console.log("Error retrieving unit conversions:", error);
      return [] as IUnitConversion[];
    });
}
